export enum Privilege {
  ManageCustomersProfiles = 'ManageCustomersProfiles',
  ManageFleetsProfiles = 'ManageFleetsProfiles',
  ManageInvoices = 'ManageInvoices',
  ManageContractsSales = 'ManageContractsSales',
}

export enum SortOptions {
  MostRecent = 'MostRecent',
  NameAZ = 'NameAZ',
  NameZA = 'NameZA',
}

export enum FormAction {
  Reset = 'Reset',
  Submit = 'Submit',
  Cancel = 'Cancel',
}

export enum Status {
  All = 'All',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  REGISTERED = 'REGISTERED',
  EXPIRED = 'EXPIRED',
  NEW = 'NEW',
  RENEWED = 'RENEWED',
  REJECTED = 'REJECTED',
  AVAILABLE = 'AVAILABLE',
  ASSIGNED = 'ASSIGNED',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  FAILED = 'FAILED',
  PASS = 'PASS',
  NOT_READY = 'NOT_READY',
}

export enum UserStatus {
  All = '',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum CustomerServiceType {
  Service = 'SERVICE',
  SAAS = 'SAAS',
}

export enum FilterByDate {
  AllTime = 'AllTime',
  Today = 'Today',
  Yesterday = 'Yesterday',
  ThisWeek = 'ThisWeek',
  Last14Day = 'Last14Day',
  LastMonth = 'LastMonth',
  LastYear = 'LastYear',
}

export enum DateRangeType {
  ALL_TIME = 'ALL_TIME',
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  THIS_WEEK = 'THIS_WEEK',
  LAST_WEEK = 'LAST_WEEK',
  LAST_TWO_WEEKS = 'LAST_TWO_WEEKS',
  THIS_MONTH = 'THIS_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  THIS_YEAR = 'THIS_YEAR',
  LAST_YEAR = 'LAST_YEAR',
  CUSTOM = 'CUSTOM',
}

export enum DateRangeTypeForMonth {
  ALL_TIME = 'ALL_TIME',
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  THIS_WEEK = 'THIS_WEEK',
  LAST_WEEK = 'LAST_WEEK',
  LAST_TWO_WEEKS = 'LAST_TWO_WEEKS',
  THIS_MONTH = 'THIS_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  CUSTOM = 'CUSTOM',
}

export enum DateRangeMode {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

export enum UserType {
  ADMIN = 'ADMIN',
  CUSTOMER = 'CUSTOMER',
  Receiver = 'RECEIVER',
  FLEET = 'FLEET',
  DRIVER = 'DRIVER',
  ORGANIZATION = 'ORGANIZATION',
}

export enum LocationType {
  Customer = 'CUSTOMER',
  Fleet = 'FLEET',
  Receiver = 'RECEIVER',
  CustomerReceiver = 'CUSTOMER_RECEIVER',
}

export enum SortDirection {
  None = '',
  Ascending = 'ASC',
  Descending = 'DESC',
}

export enum SortField {
  None = '',
  Name = 'name',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt',
  Priority = 'priority',

  // @Bassem TODO we need to standardize the naming of enums, i left the above because they are used in another modules , i think when we apply new sorting behavior to all tables we will remove the above enums.
  NONE = '',
  Type = 'type',
  NAME = 'name',
  TITLE = 'title',
  CUSTOMER_NAME = 'customerName',
  Fleet_NAME = 'fleetName',
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'updatedAt',
  PICK_UP_DATE = 'pickUpDate',
  FROM = 'from',
  TO = 'to',
  STATUS = 'status',
  COST = 'cost',
  PRICE = 'price',
  NO = 'no',
  COUNT = 'count',
  AMOUNT = 'amount',
  DUE_DAYS = 'dueDays',
  REMAINING_DUE_DAYS = 'remainingDueDays',
  INVOICE_DATE = 'invoiceDate',
  ACTIVATION_DATE = 'activationDate',
  JOIN_DATE = 'joinDate',
  TYPE = 'type',
  ID = 'id',
  GOOGLE_DISTANCE = 'googleDistance',
  COD_AMOUNT = 'codAmount',
  ORDER_NUMBER = 'orderNumber',
  PAYMENT_DATE = 'paymentDate',
  Date = 'date',
}

export enum CustomerEtaConfiguration {
  None = 'NONE',
  Google = 'GOOGLE',
  Custom = 'CUSTOM',
}

export enum NotificationType {
  Shipment = 'SHIPMENT',
  Invoice = 'INVOICE',
  Chat = 'CHAT',
}

export enum MediaType {
  COMMERCIAL_REGISTRATION = 'COMMERCIAL_REGISTRATION',
  DOCUMENT = 'DOCUMENT',
  IMAGE = 'IMAGE',
  LICENSE = 'LICENSE',
}

export enum ReceiverType {
  Customer = 'CUSTOMER',
}

export enum Mimetype {
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  SVG = 'image/svg',
  CSV = 'text/csv',
  PPT = 'application/vnd.ms-powerpoint',
  PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  PPSX = 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XLSM = 'application/vnd.ms-excel.sheet.macroenabled.12',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  WPD = 'application/vnd.wordperfect',
  TXT = 'text/plain',
  TEX = 'application/x-tex',
  PDF = 'application/pdf',
}

export enum AccountVerificationType {
  Verify = 'VERIFY',
  Reverify = 'REVERIFY',
  ResetPassword = 'RESET_PASSWORD',
}

export enum TransportationPaymentsStatus {
  ALL = 'ALL',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  PAID = 'PAID',
}

export enum ShipmentSearchFields {
  ShipmentId = 'ID',
  ReferenceNumber = 'REFERENCE_NUMBER',
}

export enum ShipmentListColumnOptionsBase {
  id = 'ID',
  createdAt = 'CREATED_AT',
  requestedDeliveryDate = 'Requested_Delivery_Date',
  from = 'FROM',
  to = 'TO',
  cost = 'COST',
  price = 'PRICE',
  status = 'STATUS',
  createdBy = 'CREATED_BY',
  truckType = 'TRUCK_TYPE_NAME',
  truckPlateNumber = 'TRUCK_PLATE_NUMBER',
  trailerDoorNumber = 'TRAILER_DOOR_NUMBER',
  product = 'PRODUCT',
  driverName = 'DRIVER_NAME',
  iqamaId = 'IQAMA_ID',
  driverAllowance = 'DRIVER_ALLOWANCE',
  mobileNumber = 'MOBILE_NUMBER',
  fleetName = 'FLEET_NAME',
  trackingType = 'TRACKING_TYPE',
  numberOfRequests = 'NUMBER_OF_REQUESTS',
  deliveryNote = 'DELIVERY_NOTE',
  notes = 'NOTES',
  action = 'ACTION',
}
export enum ShipmentListColumnOptionsForFleet {
  customerName = 'CUSTOMER_NAME',
  ReceiverName = 'RECEIVER_NAME',
}

export enum ShipmentListColumnOptionsForCustomer {
  customerName = 'BRANCH_NAME',
  ReceiverName = 'CUSTOMER_NAME',
}

export enum ShipmentListColumnOptionsForOrganization {
  customerName = 'SHIPPER',
  ReceiverName = 'FINAL_RECEIVER',
}

export enum ReportType {
  ShipmentListColumns = 'ShipmentListColumns',
}
export enum LookupType {
  Drivers = 'DRIVERS',
  Fleets = 'FLEETS',
  Receivers = 'RECEIVERS',
  Trucks = 'TRUCKS',
  Customers = 'CUSTOMERS',
  Cities = 'CITIES',
  TruckTypes = 'TRUCK_TYPES',
  Locations = 'LOCATIONS',
  ProductTypes = 'PRODUCT_TYPES',
  Users = 'USERS',
  Trailers = 'TRAILERS',
  CustomerChildren = 'CUSTOMER_CHILDREN',
  MyCustomers = 'MYCUSTOMERS',
  RCustomers = 'RCUSTOMERS',
  WccReceivers = 'WCCRECEIVERS',
  ProductItems = 'PRODUCT_ITEM',
  Order = 'ORDER',
}

export enum ShipmentDateFilterType {
  createdAt = 'createdAt',
  pickUpDate = 'pickUpDate',
}

export enum RequestType {
  Operation = 'operation',
  Technical = 'technical',
}

export enum AddLocationType {
  Location = 'Location',
  Customer = 'Customer',
}

export enum BusinessType {
  B2B = 'B2B',
  B2C = 'B2C',
}

export enum LazyLibId {
  html2canvas = 'HTML2CANVAS',
  jspdf = 'JSPDF',
  xlsx = 'XLSX',
  googleMaps = 'GOOGLE_MAPS',
  googleMapsClusterer = 'GOOGLE_MAPS_CLUSTERER',
  zenDesk = 'ze-snippet', // note zendesk won't work if this id changed
  Paytabs = 'paytabs',
  tableau = 'tableau-viz',
}

export enum ResetPasswordMethods {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export enum MobileLengthPerCode {
  Default = 7,

  // Saudi Arabia
  '+966' = 9,

  // Egypt
  '+20' = 10,

  // UAE
  '+971' = 9,

  // Kuwait
  '+965' = 8,

  // Qatar
  '+974' = 8,

  // Bahrain
  '+973' = 8,

  // Oman
  '+968' = 8,

  // Yemen
  '+967' = 9,

  // Iraq
  '+964' = 10,

  // Syria
  '+963' = 9,

  // Lebanon
  '+961' = 8,

  // Jordan
  '+962' = 9,

  // Palestine
  '+970' = 9,

  // Spain
  '+34' = 9,

  // Pakistan
  '+92' = 10,

  // Nepal
  '+977' = 10,

  // Libya
  '+218' = 9,

  // India
  '+91' = 10,

  // Bangladesh
  '+880' = 10,

  // Turkey
  '+90' = 10,

  // Morocco
  '+212' = 9,

  //Iran
  '+98' = 10,
}

export enum ShippingType {
  All = 'ALL',
  Shipper = 'SHIPPER',
  Receiver = 'RECEIVER',
}
export enum MobileNumberVerificationType {
  User = 'USER',
  Lead = 'LEAD',
}

export enum RCustomerLookupEntityType {
  Customer = 'customer',
  Receiver = 'receiver',
}

export enum RegistrationStatus {
  Init = 'Init',
  OTPRequested = 'OTPRequested',
  Verified = 'Verified',
  /** Saudi numbers only: optional CR/VAT step shown after the profile details. */
  BusinessVerification = 'BusinessVerification',
  Created = 'Created',
}

export enum PaymentOptions {
  BankTransfer = 'BANK_TRANSFER',
  Wallet = 'WALLET',
  MadaDebit = 'MADA_DEBIT',
  Sadad = 'SADAD',
}

export enum IconType {
  MaterialDesign = 'MaterialDesign',
  Image = 'Image',
  SVG = 'SVG',
}

export enum TransactionStatus {
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
}

export enum ShipmentsListType {
  Inbound = 'inbound',
  Outbound = 'outbound',
  All = 'all',
}

export enum OrganizationLabelType {
  Ycc = 'YCC',
  Basic = 'BASIC',
}

export enum LazyLibURL {
  html2canvas = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.3.3/html2canvas.min.js',
  jspdf = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.4.0/jspdf.umd.min.js',
  xlsx = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.17.2/xlsx.full.min.js',
  zenDesk = 'https://static.zdassets.com/ekr/snippet.js',
  tableau = 'https://prod-uk-a.online.tableau.com/javascripts/api/tableau.embedding.3.latest.min.js',
  // googleMaps = 'GOOGLE_MAPS',
  // googleMapsClusterer = 'GOOGLE_MAPS_CLUSTERER',
}

export enum CompanyLabelType {
  Ycc = 'YCC',
  YccCustomer = 'YCC_CUSTOMER',
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
  Saas = 'SAAS',
  Ops = 'OPS',
}

export enum CountsType {
  DRIVER = 'DRIVER',
  TRUCK = 'TRUCK',
}

export enum AssignShipmentAction {
  Override = 'Override',
  Assign = 'Assign',
  AssignAndAutoStart = 'AssignAndAutoStart',
}

export enum FleetInvoiceStatus {
  All = 'ALL',
  UnderReview = 'UNDER_REVIEW',
  InProgress = 'IN_PROGRESS',
  Paid = 'PAID',
  OverDue = 'OVER_DUE',
  Rejected = 'REJECTED',
  UnPaid = 'UNPAID',
  Drafted = 'DRAFTED',
}

export enum InvoiceDashboardStatus {
  all = 'All Invoices',
  underReview = 'Under Review',
  inProgress = 'In Progress',
  paid = 'Paid',
  overDue = 'Over Due',
}

export enum InvoiceType {
  fleet = 'FLEET',
  customer = 'CUSTOMER',
}

export enum InvoiceActivityStatus {
  created = 'CREATED',
  updated = 'UPDATED',
  rejected = 'REJECTED',
  approved = 'APPROVED',
  paid = 'PAID',
  OverDue = 'OVER_DUE',
}

export enum SearchCategory {
  Driver = 'Driver',
  Truck = 'Truck',
}

export enum GateDefinitionEnum {
  InBound = 'IN_BOUND',
  OutBound = 'OUT_BOUND',
  Both = 'BOTH',
}

/** Countries returned by `SharedAPI.getAllCountries()`, and so offered by every country picker. */
export enum SelectedCountry {
  SA = 'sa',
}
